/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'person': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M35 30.208c-.644-.366-4.843-2.851-7-3.724v-3.777c.624-.456 1-1.158 1-2.223V17.5c0-2.475-1.5-4.5-4.5-4.5S20 15.025 20 17.5v2.984c0 1.075.376 1.779 1 2.233v3.767c-2.032.873-6.356 3.357-7 3.724-.801.455-1 .888-1 1.94V34.5c0 .275.225.5.5.5h22c.275 0 .5-.225.5-.5v-2.352c0-1.052-.199-1.485-1-1.94z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/person.js